import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { DocumentTemplateModule } from '@features/document-templates/document-templates.module';
import { CopyEmailModalComponent } from '@features/system-emails/copy-email-modal/copy-email-modal.component';
import { EmailsAccordionComponent } from '@features/system-emails/emails-accordion/emails-accordion.component';
import { EmailPdfComponent } from './email-pdf/email-pdf.component';
import { ExportEmailsModalComponent } from './export-emails/export-emails-modal/export-emails-modal.component';
import { SelectEmailTemplateModule } from './select-email-template/select-email-template.module';
import { SystemEmailsPageComponent } from './system-emails-page/system-emails-page.component';
import { ToggleActivateSystemEmailModalComponent } from './toggle-activate-system-email-modal/toggle-activate-system-email-modal.component';

@NgModule({
  imports: [
    GCCoreModule,
    DocumentTemplateModule,
    SelectEmailTemplateModule
  ],
  declarations: [
    SystemEmailsPageComponent,
    CopyEmailModalComponent,
    EmailsAccordionComponent,
    ToggleActivateSystemEmailModalComponent,
    ExportEmailsModalComponent,
    EmailPdfComponent
  ],
  exports: [
    EmailsAccordionComponent
  ]
})
export class SystemEmailsModule { }
